export const TeamChatReplyPreviewTestIds = {
  CANCEL_BUTTON: 'team-chat.reply-cancel-button',
};
